import { Button } from 'antd'
import * as React from 'react'

import { useSiteLayoutContext } from '../../contexts'
import { LeftIcon, RightIcon } from '../../../icons'

import * as styles from './Trigger.module.less'

export const Trigger: React.FC = () => {
    // @ts-ignore
    const { collapsed, toggle } = useSiteLayoutContext()

    return (
        <div className={styles.trigger} onClick={toggle}>
            <Button
                onClick={toggle}
                type="default"
                shape="circle"
                icon={collapsed ? <RightIcon /> : <LeftIcon />}
                size="middle"
            />
        </div>
    )
}
